"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { CreateWaveOutcomeConfig, CreateWaveOutcomeConfigWinnersConfig } from "@/types/waves.types";
import { CreateWaveOutcomeConfigWinnersCreditValueType, CreateWaveOutcomeType } from "@/types/waves.types";
import CreateWaveOutcomesWinners from "../winners/CreateWaveOutcomesWinners";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function CreateWaveOutcomesCICRank(t0) {
  const $ = _c(32);
  const {
    onOutcome,
    onCancel
  } = t0;
  const outcomeType = CreateWaveOutcomeType.NIC;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: outcomeType,
      title: null,
      credit: null,
      category: null,
      winnersConfig: {
        creditValueType: CreateWaveOutcomeConfigWinnersCreditValueType.ABSOLUTE_VALUE,
        totalAmount: 0,
        winners: [{
          value: 0
        }]
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [outcome, setOutcome] = useState(t1);
  const [totalValueError, setTotalValueError] = useState(false);
  const [percentageError, setPercentageError] = useState(false);
  let t2;
  if ($[1] !== outcome) {
    t2 = winnersConfig => {
      setTotalValueError(false);
      setPercentageError(false);
      setOutcome({
        ...outcome,
        winnersConfig
      });
    };
    $[1] = outcome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setWinnersConfig = t2;
  let t3;
  if ($[3] !== outcome.winnersConfig?.winners) {
    t3 = () => outcome.winnersConfig?.winners.reduce(_temp, 0) ?? null;
    $[3] = outcome.winnersConfig?.winners;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getWinnersTotal = t3;
  let t4;
  if ($[5] !== getWinnersTotal || $[6] !== outcome.winnersConfig?.creditValueType || $[7] !== outcome.winnersConfig?.totalAmount) {
    t4 = () => {
      if (outcome.winnersConfig?.creditValueType === CreateWaveOutcomeConfigWinnersCreditValueType.ABSOLUTE_VALUE) {
        const totalValue = getWinnersTotal();
        if (!totalValue) {
          return true;
        }
        if (totalValue !== outcome.winnersConfig?.totalAmount) {
          return true;
        }
      } else {
        return !outcome.winnersConfig?.totalAmount;
      }
      return false;
    };
    $[5] = getWinnersTotal;
    $[6] = outcome.winnersConfig?.creditValueType;
    $[7] = outcome.winnersConfig?.totalAmount;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const getTotalValueError = t4;
  let t5;
  if ($[9] !== getWinnersTotal || $[10] !== outcome.winnersConfig?.creditValueType) {
    t5 = () => {
      if (outcome.winnersConfig?.creditValueType !== CreateWaveOutcomeConfigWinnersCreditValueType.PERCENTAGE) {
        return false;
      }
      return getWinnersTotal() !== 100;
    };
    $[9] = getWinnersTotal;
    $[10] = outcome.winnersConfig?.creditValueType;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const getPercentageError = t5;
  let t6;
  if ($[12] !== getPercentageError || $[13] !== getTotalValueError || $[14] !== onOutcome || $[15] !== outcome) {
    t6 = () => {
      const totalValueError_0 = getTotalValueError();
      const percentageError_0 = getPercentageError();
      setTotalValueError(totalValueError_0);
      setPercentageError(percentageError_0);
      if (totalValueError_0 || percentageError_0) {
        return;
      }
      onOutcome(outcome);
    };
    $[12] = getPercentageError;
    $[13] = getTotalValueError;
    $[14] = onOutcome;
    $[15] = outcome;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const onSubmit = t6;
  let t7;
  if ($[17] !== outcome.winnersConfig || $[18] !== percentageError || $[19] !== setWinnersConfig || $[20] !== totalValueError) {
    t7 = outcome.winnersConfig && <CreateWaveOutcomesWinners winnersConfig={outcome.winnersConfig} outcomeType={outcomeType} totalValueError={totalValueError} percentageError={percentageError} setWinnersConfig={setWinnersConfig} />;
    $[17] = outcome.winnersConfig;
    $[18] = percentageError;
    $[19] = setWinnersConfig;
    $[20] = totalValueError;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== onCancel) {
    t8 = <button onClick={onCancel} type="button" className="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-border-iron-700 hover:tw-bg-iron-700">Cancel</button>;
    $[22] = onCancel;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== onSubmit) {
    t9 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={false} padding="tw-px-4 tw-py-3">Save</PrimaryButton>;
    $[24] = onSubmit;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div className="tw-flex tw-justify-end tw-gap-x-3">{t8}{t9}</div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t7) {
    t11 = <div className="tw-col-span-full tw-flex tw-flex-col tw-gap-y-2"><div className="tw-flex tw-flex-col tw-gap-y-6">{t7}{t10}</div></div>;
    $[29] = t10;
    $[30] = t7;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}
function _temp(acc, winner) {
  return acc + winner.value;
}